import { render, staticRenderFns } from "./SubOfficeAggregation.vue?vue&type=template&id=79b6c8ca&scoped=true&"
import script from "./SubOfficeAggregation.vue?vue&type=script&lang=js&"
export * from "./SubOfficeAggregation.vue?vue&type=script&lang=js&"
import style0 from "./SubOfficeAggregation.vue?vue&type=style&index=0&id=79b6c8ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b6c8ca",
  null
  
)

export default component.exports